import { getTheme, hexToRgb } from './palette';

/** Council brand (logo + brand CSS vars) comes from env / palette.js. Chrome tokens are shared. */

const theme = getTheme();
const rgb = (hex) => hexToRgb(hex, theme.primary);

const vars = {
    '--brand-primary': theme.primary,
    '--brand-primary-mid': theme.primaryMid,
    '--brand-primary-dark': theme.primaryDark,
    '--brand-primary-light': theme.primaryLight,
    '--brand-accent': theme.accent,
    '--brand-primary-rgb': rgb(theme.primary),
    '--brand-primary-mid-rgb': rgb(theme.primaryMid),
    '--brand-primary-dark-rgb': rgb(theme.primaryDark),
    '--brand-primary-light-rgb': rgb(theme.primaryLight),
    '--brand-accent-rgb': rgb(theme.accent),
    '--nav-bg': theme.navBg,
    '--nav-bg-mid': theme.navBgMid,
    '--nav-bg-end': theme.navBgEnd,
    '--nav-fg': theme.navFg,
    '--nav-theme': theme.navTheme,
    '--focus-ring': theme.focusRing,
};

const root = document.documentElement;
Object.keys(vars).forEach((key) => root.style.setProperty(key, vars[key]));
root.setAttribute('data-nav-theme', theme.navTheme);
root.setAttribute('data-app-env', theme.envName);

export default theme;
